import type { RacquetSportId } from '@court-sync/shared';
import { SportIcon, type SportIconVariant } from './SportIcons';

export function SportGlyph({
  sportId,
  className = 'h-4 w-4',
  variant = 'dark',
}: {
  sportId: RacquetSportId;
  className?: string;
  variant?: SportIconVariant;
}) {
  return <SportIcon sportId={sportId} className={className} variant={variant} />;
}
